export const color="#3d4147";
export const SEARCH_STOCK = "SEARCH_STOCK";
export const REQUEST_STOCK = "REQUEST_STOCK";
export const RECEIVE_STOCK = "RECEIVE_STOCK";
export const FETCH_STOCK = "FETCH_STOCK";
export const RECEIVE_PROFILE = "RECEIVE_PROFILE";
export const ADD_STOCK = "ADD_STOCK";